module.exports = {
  "country": "BE",
  "artist": "Tonia",
  "song": "Un peu de Poivre, un peu de sel",
  "year": "1966",
  "place": "4",
  "spotify": ""
};